import Navbar from "./components/Navbar";
import HeroSlider from "./components/HeroSlider";
import BrandLogos from "./components/BrandLogos";
import ControlsSection from "./components/ControlsSection";
import CoolingSection from "./components/CoolingSection";
import WhyUsSection from "./components/WhyUsSection";
import ReviewsSection from "./components/ReviewsSection";
import HeatingSection from "./components/HeatingSection";
import AboutSection from "./components/AboutSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";

export default function HomePage() {
  return (
    <div className="min-h-screen w-full font-sans">
      <Navbar />
      <HeroSlider />
      <BrandLogos />
      <ControlsSection />
      <CoolingSection />
      <WhyUsSection />
      <ReviewsSection />
      <HeatingSection />
      <AboutSection />
      <ContactSection />
      <Footer />
    </div>
  );
}
